import { Badge } from '@/components/ui/Badge';

const signalMap: Record<string, { variant: 'success' | 'warning' | 'error' | 'info' | 'purple' | 'default'; label: string }> = {
  lead_score: { variant: 'info', label: 'Lead' },
  churn_risk: { variant: 'error', label: 'Churn Risk' },
  upsell: { variant: 'success', label: 'Upsell' },
  competitive: { variant: 'warning', label: 'Competitive' },
  revenue_leak: { variant: 'error', label: 'Revenue Leak' },
  engagement: { variant: 'purple', label: 'Engagement' },
};

interface Props {
  type: string;
}

export function SignalTypeBadge({ type }: Props) {
  const config = signalMap[type] || { variant: 'default' as const, label: type };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
